<template>
  <popup @codd_close="$emit('close')" size="large" :tooltip="true">
    <div class="tooltip-body">
      <div class="d-flex w-100 justify-content-end">
        <span class="close" @click="$emit('close')"> &times;</span>
      </div>
      <div class="tooltip-content d-flex flex-column"
           v-html="this.tooltipContent">
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from "@/components/popup/Popup";

export default {
  name: "PopupTooltip",

  props: ['tooltipContent'],

  components: {
    Popup
  },
}
</script>

<style scoped lang="scss">
  .tooltip-body {
    padding: 25px 40px;

    .tooltip-content {
      max-width: 100%;
      height: auto;

      iframe {
        height: 100%;
      }
    }

    .close {
      transition: all ease 0.3s;
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
    }
  }
</style>